import React, { useState } from "react";
import { COLORS, AI_AT_SCALE } from "../data/profile";
import { useLang, t } from "../LanguageContext";

export default function AiTab() {
  const { lang } = useLang();
  const [expanded, setExpanded] = useState(null);

  return (
    <div>
      <h2 style={{ fontFamily: "'DM Serif Display', serif", fontSize: "clamp(20px, 5vw, 24px)", marginBottom: 6, color: COLORS.text }}>
        {lang === "en" ? "AI Implementation at Scale" : "Implémentation IA à Grande Échelle"}
      </h2>
      <p style={{ fontSize: 14, color: "#555", lineHeight: 1.7, marginBottom: 28 }}>
        {t(AI_AT_SCALE.intro, lang)}
      </p>

      {AI_AT_SCALE.cases.map((c, i) => (
        <div
          key={i}
          style={{
            background: "#fff",
            border: `1px solid ${expanded === i ? COLORS.accent : COLORS.border}`,
            borderRadius: 12,
            marginBottom: 12,
            overflow: "hidden",
            transition: "border-color 0.25s ease",
          }}
        >
          <button
            onClick={() => setExpanded(expanded === i ? null : i)}
            style={{
              width: "100%",
              padding: "16px 18px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              background: "none",
              border: "none",
              cursor: "pointer",
              textAlign: "left",
              gap: 10,
              minHeight: 44,
            }}
          >
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{
                fontSize: "clamp(14px, 3.5vw, 16px)",
                fontWeight: 600,
                color: COLORS.text,
                lineHeight: 1.4,
                fontFamily: "'DM Serif Display', serif",
              }}>
                {t(c.title, lang)}
              </div>
              <div style={{ fontSize: 12, color: COLORS.accent, marginTop: 6, fontWeight: 500 }}>
                {t(c.metrics, lang)}
              </div>
            </div>
            <span
              style={{
                fontSize: 11,
                color: COLORS.accent,
                fontWeight: 600,
                background: "rgba(140,123,107,.1)",
                padding: "5px 10px",
                borderRadius: 10,
                whiteSpace: "nowrap",
                flexShrink: 0,
                border: "1px solid rgba(140,123,107,.2)",
                transition: "background 0.2s",
              }}
            >
              {expanded === i ? "−" : "+"}
            </span>
          </button>

          {expanded === i && (
            <div
              className="expand-transition"
              style={{
                padding: "0 18px 18px",
                borderTop: "1px solid #F0EDE8",
              }}
            >
              <p style={{ fontSize: 14, lineHeight: 1.8, color: "#444", marginTop: 16 }}>
                {t(c.description, lang)}
              </p>
              <div style={{ display: "flex", gap: 6, marginTop: 12, flexWrap: "wrap" }}>
                {c.tags.map((tag) => (
                  <span
                    key={tag}
                    style={{
                      fontSize: 11,
                      color: COLORS.green,
                      background: "#EBF0ED",
                      padding: "4px 10px",
                      borderRadius: 8,
                      fontWeight: 500,
                    }}
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
      ))}

      {/* CTA */}
      <div style={{
        background: COLORS.dark,
        borderRadius: 12,
        padding: "20px 18px",
        color: "#F5F0EB",
        marginTop: 24,
      }}>
        <p style={{ fontSize: 14, lineHeight: 1.7, opacity: 0.9, margin: 0 }}>
          {t(AI_AT_SCALE.cta, lang)}
        </p>
        <a
          href={`mailto:chris@kohlerholding.com?subject=${encodeURIComponent(lang === "en" ? "AI Implementation Discussion" : "Discussion Implémentation IA")}`}
          style={{
            display: "inline-block",
            marginTop: 14,
            background: COLORS.accent,
            color: "#fff",
            padding: "10px 22px",
            borderRadius: 8,
            fontSize: 14,
            fontWeight: 600,
            textDecoration: "none",
            minHeight: 44,
            lineHeight: "24px",
          }}
        >
          {lang === "en" ? "Let's Talk →" : "Discutons →"}
        </a>
      </div>
    </div>
  );
}
